import Validation from 'utils/validation.utils';

export const initialState = (state = {}) => {
  const {
    customerId = {
      value: '',
      disabled: false
    },
    productId = {
      value: '',
      disabled: false
    },
    type = {
      value: '',
      disabled: false
    },
    amount = {
      value: '',
      disabled: false
    },
    tranCode = {
      value: '',
      disabled: false
    },
    remarks = {
      value: '',
      disabled: false
    }
  } = state;
  return {
    customerId: {
      name: 'customerId',
      ...customerId
    },
    productId: {
      name: 'productId',
      validations: [Validation.required({ noMessage: true })],
      required: true,
      ...productId
    },
    type: {
      name: 'type',
      validations: [Validation.required({ noMessage: true })],
      required: true,
      ...type
    },
    amount: {
      name: 'amount',
      label: 'Amount',
      validations: [Validation.required({ noMessage: true })],
      required: true,
      placeholder: '0.00',
      ...amount
    },
    orNumber: {
      name: 'orNumber',
      label: 'OR Number',
      required: false,
      ...remarks
    },
    tranCode: {
      name: 'tranCode',
      label: 'Trans Code',
      required: true,
      ...tranCode
    },
    remarks: {
      name: 'remarks',
      label: 'Remarks',
      required: false,
      ...remarks
    }
  };
};
